export const environment = {
  production: true,
  apiPrefix: '..',
  captchaSiteKey: '6Lf6uyEjAAAAACVDlmkX4AixlknexRCkay29UXfy'
};
